const focusableSelector =
  'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, iframe, audio[controls], video[controls], [tabindex]:not([tabindex="-1"])';

export function syncVueCarouselCloneInert(rootEl) {
  if (!rootEl || typeof rootEl.querySelectorAll !== 'function') {
    return;
  }
  const supportsInert = typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
  const hiddenSlides = rootEl.querySelectorAll('li.carousel__slide[aria-hidden="true"]');
  const visibleSlides = rootEl.querySelectorAll('li.carousel__slide:not([aria-hidden="true"])');

  if (supportsInert) {
    hiddenSlides.forEach(li => {
      li.inert = true;
    });
    visibleSlides.forEach(li => {
      li.inert = false;
    });
    return;
  }

  hiddenSlides.forEach(li => {
    li.querySelectorAll(focusableSelector).forEach(node => {
      if (!node.hasAttribute('data-vc-inert-tab')) {
        const prev = node.hasAttribute('tabindex') ? node.getAttribute('tabindex') : '';
        node.setAttribute('data-vc-inert-tab', prev);
      }
      node.setAttribute('tabindex', '-1');
    });
  });
  visibleSlides.forEach(li => {
    li.querySelectorAll('[data-vc-inert-tab]').forEach(node => {
      const prev = node.getAttribute('data-vc-inert-tab');
      node.removeAttribute('data-vc-inert-tab');
      if (prev === '') {
        node.removeAttribute('tabindex');
      } else {
        node.setAttribute('tabindex', prev);
      }
    });
  });
}
